module.exports = __webpack_public_path__ + "img/phone_content.f5b4a7f7.jpg";